import React, { useEffect, useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import './SalesLeaderboardScreen.css';
import backIcon from '../assets/backspace-icon.png';

function SalesLeaderboardScreen() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const res = await api.get('/receipts/leaderboard?limit=100');
        setRows(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error('❌ Failed to load leaderboard:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchLeaderboard();
  }, []);

  const medalForIndex = (idx) => {
    if (idx === 0) return '🥇';
    if (idx === 1) return '🥈';
    if (idx === 2) return '🥉';
    return null;
  };

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-header">
        <img
          src={backIcon}
          alt="Back"
          className="leaderboard-back-icon"
          onClick={() => navigate(-1)}
        />
        <h2>Sales Leaderboard</h2>
      </div>

      <div className="leaderboard-scroll">
        {loading ? (
          <p className="lb-msg">Loading…</p>
        ) : rows.length === 0 ? (
          <p className="lb-msg">No sales yet.</p>
        ) : (
          <div className="leaderboard-list">
            {rows.map((r, idx) => {
              const thumb = Array.isArray(r.productMedia) ? r.productMedia[0] : null;
              const rankClass =
                idx === 0 ? 'rank-1' : idx === 1 ? 'rank-2' : idx === 2 ? 'rank-3' : '';
              const medal = medalForIndex(idx);

              return (
                <div
                  key={r.productId}
                  className={`leaderboard-row ${rankClass}`}
                  onClick={() => navigate(`/product/${r.productId}`)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigate(`/product/${r.productId}`);
                    }
                  }}
                  title="Open product"
                >
                  {/* Left edge color bar */}
                  <div className="lb-rank-bar" />

                  <div className="lb-rank">{idx + 1}</div>

                  {thumb ? (
                    <img src={thumb} alt="" className="lb-thumb" loading="lazy" />
                  ) : (
                    <div className="lb-thumb placeholder">No image</div>
                  )}

                  <div className="lb-info">
                    <div className="lb-name-row">
                      <span className="lb-name" title={r.productName}>
                        {r.productName}
                      </span>
                      {medal && (
                        <span className="lb-medal" aria-label={`Rank ${idx + 1}`}>
                          {medal}
                        </span>
                      )}
                    </div>
                    <div className="lb-sales">
                      {r.salesCount} sale{r.salesCount !== 1 ? 's' : ''}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default SalesLeaderboardScreen;
